<ng-container *ngIf="readonly">
  <app-view-item
    text="{{ value | date: format }}"
    [borderless]="borderless"
  ></app-view-item>
  <span *ngIf="!value">&nbsp;</span>
</ng-container>

<nz-date-picker
  #datepicker
  *ngIf="!readonly"
  [(ngModel)]="date"
  (ngModelChange)="onModelChange($event)"
  [nzAllowClear]="nzAllowClear"
  [nzFormat]="format"
  [nzInputReadOnly]="disabled"
  [nzDisabled]="nzDisabled"
  [class.bg-grey-lighter]="readonly && !borderless"
  class="width-100"
  (keydown.enter)="onKeyUp($event)"
  [nzPlaceHolder]="this.format"
>
</nz-date-picker>
<!--  [tabindex]="tabindex"-->
